import { z } from 'zod'
import {
  discountDataSchema,
  errorDataSchema,
  eventDataSchema,
} from '../../common.schema'

export const DiscountErrorSchema = z.object({
  event: z.literal('discount_error'),

  discount_data: discountDataSchema,
  event_data: eventDataSchema,
  error_data: errorDataSchema,
})

export type DiscountErrorEvent = z.infer<typeof DiscountErrorSchema>
